import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { toast } from "react-hot-toast";

import { RegistroContaReceberDTO } from "types/dto/RegistroContaReceberDTO";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import usePostAlterarCondominioContextoToken from "hooks/condominio/usePostAlterarCondominioContextoToken";

type Request = {
  processoJudicialId: number;
  deveBuscarIdsCobrancasDoProcesso: boolean;
  condominioId: number;
};

export const useGetIdsCobrancasVinculadasAoProcesso = (request: Request) => {
  const { alterarCondominioContextoToken } = usePostAlterarCondominioContextoToken();
  const { iniciarAcordosV1 } = IntegracaoV1();
  const onError = () => {
    toast.error("Erro ao buscar todas as cobranças vinculadas ao processo");
  };
  const onSuccess = async (resp: number[]) => {
    await alterarCondominioContextoToken(request.condominioId);
    iniciarAcordosV1(resp);
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<RegistroContaReceberDTO>>({
    key: ["ids-cobrancas-vinculadas-ao-processo", request.processoJudicialId],
    url: api.processosJudiciaisContaReceber.getIdsCobrancasVinculadosAoProcesso,
    params: request,
    enabled: request.processoJudicialId !== undefined && request.deveBuscarIdsCobrancasDoProcesso,
    config,
    onError,
    onSuccess,
  });
};
